import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "@/assets/styles/main.css";

import "slick-carousel/slick/slick.css";
import "jquery";

createApp(App).use(store).use(router).mount("#app");
